import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class SourceInfoService {

  constructor(private http: HttpClient) {
  }
  public baseUrl = environment.baseUrl;
  public getSourceInfoCollection(isbn: String = ""): Observable<any> {
	  if(isbn === undefined || isbn == "") {
		  isbn = localStorage.getItem('isbn');
	  }
    let sourceInfoUrl = `${this.baseUrl}/testbuilder/api/v2/sourceInfo/${isbn}`;
    const virtualProductId = localStorage.getItem("virtualProductId");
    if (virtualProductId) {
      sourceInfoUrl += `?virtualProductId=${virtualProductId}`;
    }
    //  let sourceInfoUrl = '../../../assets/stubs/sourceInfo.json';
     return this.http.get(sourceInfoUrl);
  }

  public viewBankInfo(bankId: any, virtualBankId?: number): Observable<any> {
    const baseUrl = environment.baseUrl;
    //  let listUrl = '../../../assets/stubs/moreInfo.json';
    const release = localStorage.getItem("release");
    
    // Build query parameters dynamically
    const queryParams = [];
    if (release) {
        queryParams.push(`releaseYear=${release}`);
    }
    if (virtualBankId) {
        queryParams.push(`virtualBankId=${virtualBankId}`);
    } 
    const listUrl = `${baseUrl}/testbuilder/api/bankInfo/${bankId}${queryParams.length ? `?${queryParams.join('&')}` : ''}`;
    return this.http.get(listUrl);
  }

}
